export const allDetails = [{
    cardClass: "card-body primary",
    title: "New Orders",
    dataInNumber: "2,908",
    spanClass: "font-primary f-12 f-w-500",
    iconClass: "icon-arrow-up",
    status: "+20%",
    svgIcon: "new-order"
},
{
    cardClass: "card-body warning",
    title: "New Customers",
    dataInNumber: "2,435",
    spanClass: "font-warning f-12 f-w-500",
    iconClass: "icon-arrow-up",
    status: "+50%",
    svgIcon: "customers"
},
{
    cardClass: "card-body secondary",
    title: "Average Sale",
    dataInNumber: "$389k",
    spanClass: "font-secondary f-12 f-w-500",
    iconClass: "icon-arrow-down",
    status: "-10%",
    svgIcon: "sale"
},
{
    cardClass: "card-body success",
    title: "Gross Profit",
    dataInNumber: "$3,908",
    spanClass: "font-primary f-12 f-w-500",
    iconClass: "icon-arrow-up",
    status: "+80%",
    svgIcon: "profit"
}]

export const valuableCustomer = [{
    name: "Jane Cooper",
    email: "alma.lawson@gmail.com",
    image: require("@/assets/images/dashboard/user/1.jpg"),
},
{
    name: "Cameron Willia",
    email: "tim.jennings@gmail.com",
    image: require("@/assets/images/dashboard/user/2.jpg"),
},
{
    name: "Floyd Miles",
    email: "kenzi.lawson@gmail.com",
    image: require("@/assets/images/dashboard/user/6.jpg"),
},
{
    name: "Dianne Russell",
    email: "curtis.weaver@gmail.com",
    image: require("@/assets/images/dashboard/user/5.jpg"),
},
{
    name: "Guy Hawkins",
    email: "curtis.weaver@gmail.com",
    image: require("@/assets/images/dashboard/user/3.jpg"),
}
]

export const orderOverview = [{
    svgIcon: "orders",
    title: "Orders",
    overviewInNumber: "10,098"
},
{
    svgIcon: "expense",
    title: "Earning",
    overviewInNumber: "$12,678"
},
{
    svgIcon: "doller-return",
    title: "Refunds",
    overviewInNumber: "3,001"
}
]

export const  topcategories =[{
    image: require("@/assets/images/dashboard-2/category/1.png"),
    name: "Food & Drinks",
    orders: "12,200"
}, {
    image: require("@/assets/images/dashboard-2/category/2.png"),
    name: "Furniture",
    orders: "7,510"
}, {
    image: require("@/assets/images/dashboard-2/category/3.png"),
    name: "Grocery",
    orders: "15,475"
}, {
    image: require("@/assets/images/dashboard-2/category/4.png"),
    name: "Electronics",
    orders: "27,840"
}, {
    image: require("@/assets/images/dashboard-2/category/5.png"),
    name: "Toys & Games",
    orders: "8,788"
}, {
    image: require("@/assets/images/dashboard-2/category/6.png"),
    name: "Desktop",
    orders: "10,673"
}, {
    image: require("@/assets/images/dashboard-2/category/7.png"),
    name: "Mobile & Accessories",
    orders: "5,129"
}, ]

export const    activities = [{
    class: "activity-dot-warning",
    date: "2nd Sep, Today",
    title: "Anamika Comments this Poducts",
    decription: "I don't like things to be staged or fussy."
}, {
    class: "activity-dot-secondary",
    date: "3nd Sep, 2022",
    title: "  Jacksion Purchase ",
    decription: "Fashion fades, only style remain the same."
}, {
    class: "activity-dot-success",
    date: "2nd Sep, Today",
    title: " Anamika Comments this Poducts",
    decription: "I like to be real. I don't like things to staged."
}]

export const products =[{
    image: require("@/assets/images/dashboard-2/product/1.png")
}, {
    image: require("@/assets/images/dashboard-2/product/2.png")
},
{
    image: require("@/assets/images/dashboard-2/product/3.png")
}
]